// Import the functions you need from the SDKs you need
import {
  EmailAuthProvider,
  confirmPasswordReset,
  getAuth,
  reauthenticateWithCredential,
  sendPasswordResetEmail,
  updatePassword,
  verifyPasswordResetCode,
} from "firebase/auth";
import { FirebaseApp } from "./init";

export const FirebaseAuth = getAuth(FirebaseApp);

export const GetCurrentUser = () => {
  return getAuth(FirebaseApp).currentUser;
};

export const SignOut = async () => {
  return await getAuth(FirebaseApp).signOut();
};

export const SendResetPasswordEmail = async (email) => {
  const origin = process.env.REACT_APP_CLIENT_URL
    || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

  return await sendPasswordResetEmail(FirebaseAuth, email, {
    url: `${origin}/auth`,
    handleCodeInApp: true,
  });
};

export const VerifyResetPasswordCode = async (oobCode) => {
  return await verifyPasswordResetCode(FirebaseAuth, oobCode);
};

export const ConfirmResetPassword = async (oobCode, newPassword) => {
  return await confirmPasswordReset(FirebaseAuth, oobCode, newPassword);
};

export const ChangeUserPassword = async ({ currentPassword, newPassword }) => {
  const currentUser = FirebaseAuth.currentUser;

  if (!currentUser || !currentUser.email) {
    throw new Error('No authenticated user found. Please sign in again.');
  }

  const credential = EmailAuthProvider.credential(currentUser.email, currentPassword);
  await reauthenticateWithCredential(currentUser, credential);
  await updatePassword(currentUser, newPassword);
};